// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import simpleParallax from 'simple-parallax-js';

const fragments = {
  ELEMENT: '[data-fragment="Parallax.element"]'
};

export default class Parallax extends WebComponent {
  constructor (props) {
    super(props);

    this.state = {

    };
  }

  didMount() {
    this.elements = this.element.querySelectorAll(fragments.ELEMENT);
    this.parallax = new simpleParallax(this.elements, {
      scale: 1.1,
      overflow: true,
      delay: .6
    });
  }

  willUnMount() {
    this.parallax.destroy();
  }
  update() {

  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Parallax.js